import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { template } from 'lodash-es';

export class TranslateHandler implements MissingTranslationHandler {
  handle({ key, interpolateParams, translateService }: MissingTranslationHandlerParams) {
    const withExtractedParams = this.#extractParamsFromDataTag(key);
    if (withExtractedParams) return translateService.instant(withExtractedParams.key, withExtractedParams.params);
    try {
      // {x} (this site's own keys) and {{x}} (the ngx-translate form the catalogues use) - 26.09.2026: {{x}} left "{value}"
      // one capture group only - lodash's template reads the interpolate value from the first group
      if (interpolateParams) return template(key, { interpolate: /\{\{?\s*([\w.]+)\s*\}?\}/g })(interpolateParams);
    } catch (error) {
      console.error("Can't parse locale string with params", { key, interpolateParams, error });
    }

    return key;
  }
  #extractParamsFromDataTag(originalString: string) {
    const dataStartIndex = originalString.indexOf('<data>');
    const dataEndIndex = originalString.lastIndexOf('</data>');
    if (dataEndIndex < 0) return;
    const key = originalString.substring(0, dataStartIndex);

    const jsonData = originalString.substring(dataStartIndex + '<data>'.length, dataEndIndex).replace(/'/g, '"');
    try {
      const params = JSON.parse(jsonData);
      return { key, params };
    } catch (error) {
      console.error("Can't parse params from locale string data tag", { originalString, error });
      return { key, params: {} };
    }
  }
}
